module.exports = __webpack_public_path__ + "static/edward-650abb0775e2341c53877785178dbcab.jpg";